import { getFirestore, collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { app } from "../../firebase-config.js";

const db = getFirestore(app);

/**
 * AdminPlazaService
 * 
 * separated from main PlazaService to reduce bundle size.
 * Handles heavy admin operations like sync, repairs, etc.
 * Loaded dynamically only when needed.
 */
export const AdminPlazaService = {
    /**
     * [ADMIN] Sync Counts (Repair Tool)
     * Recalculates comment counts for all feeds.
     * Use sparingly as it reads all comments.
     */
    async adminSyncCounts(progressCallback) {
        // 1. Get All Feeds
        const feedsSnap = await getDocs(collection(db, 'plaza_feeds'));
        const total = feedsSnap.size;
        let processed = 0;
        let updated = 0;

        for (const docSnapshot of feedsSnap.docs) {
            const feedId = docSnapshot.id;
            const currentCount = docSnapshot.data().commentCount || 0;

            // 2. Count Real Comments
            // Optimized: Use getCountFromServer if available (v9.11+), otherwise getDocs
            // For older SDKs, we use getDocs.
            // Let's use getDocs for compatibility or 'count()' if we are sure.
            // Using getDocs for safety.
            const commentsSnap = await getDocs(collection(db, 'plaza_feeds', feedId, 'comments'));
            const realCount = commentsSnap.size;

            if (currentCount !== realCount) {
                await updateDoc(doc(db, 'plaza_feeds', feedId), {
                    commentCount: realCount
                });
                updated++;
            }

            processed++;
            if (progressCallback) progressCallback(processed, total);
        }

        return { total, updated };
    }
};
